import { AnyAction } from 'redux';
import {
  GlobalActions,
  InitializeShopPayload,
  isAzam,
  KdvMetadaten,
} from '@ps20-frontend/shop-integration-redux';
import { IAppState } from '../localStore';
import { isSdwSession } from '../selector/transient-state.selector';

export const kdvReducer = function (
  sectionState: IAppState['kdv'] = null,
  action: AnyAction,
  state: IAppState,
): IAppState['kdv'] {
  switch (action.type) {
    case GlobalActions.SHOP_INIT: {
      const actionPayload: InitializeShopPayload = action.payload;
      const kdv = actionPayload.kdv;
      return {
        sessionId: kdv.sessionId,
        perId: kdv.perId || actionPayload.sdw?.partyId,
        vorId: kdv.vorId,
        copyFlag: kdv.copyFlag,
        azamVorgangsId: actionPayload.azamVorgangsId,
        azamCryptId: actionPayload.av && actionPayload.av.cryptId,
        partyId: actionPayload.sdw?.partyId,
        amisupd: kdv.amisupd,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return {
        ...sectionState,
        azamVorgangsId:
          (isAzam(state.transientState.role) && sectionState.azamVorgangsId) || sectionState.vorId,
      };
    }
    case GlobalActions.SAVE_STATUS_RECEIVED: {
      return {
        ...sectionState,
        azamCryptId:
          isAzam(state.transientState.role) || isSdwSession(state) ? action.payload.cryptId : null,
      };
    }
    case GlobalActions.KDV_METADATEN_INIT: {
      const actionPayload: KdvMetadaten = action.payload;
      return {
        ...sectionState,
        vermerk: actionPayload.vermerk,
        gesamtbeitrag: actionPayload.gesamtbeitrag,
      };
    }
    default:
      return sectionState;
  }
};
